export const localizationMixin = {
    methods: {
        getLocalization: function (culture) {
            var localization = null;
            switch (culture) {
                case "de":
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 1,
                        days: {
                            // full day names
                            names: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                            // abbreviated day names
                            namesAbbr: ["Sonn", "Mon", "Dien", "Mitt", "Donn", "Fre", "Sams"],
                            // shortest day names
                            namesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
                        },

                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember", ""],
                            // abbreviated month names
                            namesAbbr: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dez", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["AM", "am", "AM"],
                        PM: ["PM", "pm", "PM"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "A.D.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            d: "dd.MM.yyyy",
                            D: "dddd, d. MMMM yyyy",
                            t: "HH:mm",
                            T: "HH:mm:ss",
                            f: "dddd, d. MMMM yyyy HH:mm",
                            F: "dddd, d. MMMM yyyy HH:mm:ss",
                            M: "dd MMMM",
                            Y: "MMMM yyyy"

                        },
                        percentsymbol: "%",
                        currencysymbol: "€",
                        currencysymbolposition: "after",
                        decimalseparator: '.',
                        thousandsseparator: ',',
                        pagergotopagestring: "Gehe zu",
                        pagershowrowsstring: "Zeige Zeile:",
                        pagerrangestring: " von ",
                        pagerpreviousbuttonstring: "nächster",
                        pagernextbuttonstring: "voriger",
                        pagerfirstbuttonstring: "first",
                        pagerlastbuttonstring: "last",
                        groupsheaderstring: "Ziehen Sie eine Kolumne und legen Sie es hier zu Gruppe nach dieser Kolumne",
                        sortascendingstring: "Sortiere aufsteigend",
                        sortdescendingstring: "Sortiere absteigend",
                        sortremovestring: "Entferne Sortierung",
                        groupbystring: "Group By this column",
                        groupremovestring: "Remove from groups",
                        filterclearstring: "Löschen",
                        filterstring: "Filter",
                        filtershowrowstring: "Zeige Zeilen, in denen:",
                        filterorconditionstring: "Oder",
                        filterandconditionstring: "Und",
                        filterselectallstring: "(Alle auswählen)",
                        filterchoosestring: "Bitte wählen Sie:",
                        filterstringcomparisonoperators: ['leer', 'nicht leer', 'enthält', 'enthält(gu)',
                            'nicht enthalten', 'nicht enthalten(gu)', 'beginnt mit', 'beginnt mit(gu)',
                            'endet mit', 'endet mit(gu)', 'equal', 'gleich(gu)', 'null', 'nicht null'
                        ],
                        filternumericcomparisonoperators: ['gleich', 'nicht gleich', 'weniger als', 'kleiner oder gleich', 'größer als', 'größer oder gleich', 'null', 'nicht null'],
                        filterdatecomparisonoperators: ['gleich', 'nicht gleich', 'weniger als', 'kleiner oder gleich', 'größer als', 'größer oder gleich', 'null', 'nicht null'],
                        filterbooleancomparisonoperators: ['gleich', 'nicht gleich'],
                        validationstring: "Der eingegebene Wert ist ungültig",
                        emptydatastring: "Nokeine Daten angezeigt",
                        filterselectstring: "Wählen Sie Filter",
                        loadtext: "Loading...",
                        clearstring: "Löschen",
                        todaystring: "Heute"
                    }
                    break;
                case "it":
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 1,
                        days: {
                            // full day names
                            names: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
                            // abbreviated day names
                            namesAbbr: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
                            // shortest day names
                            namesShort: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"]
                        },
                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre", ""],
                            // abbreviated month names
                            namesAbbr: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["AM", "am", "AM"],
                        PM: ["PM", "pm", "PM"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "A.D.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            // short date pattern
                            d: "M/d/yyyy",
                            // long date pattern
                            D: "dddd, MMMM dd, yyyy",
                            // short time pattern
                            t: "h:mm tt",
                            // long time pattern
                            T: "h:mm:ss tt",
                            // long date, short time pattern
                            f: "dddd, MMMM dd, yyyy h:mm tt",
                            // long date, long time pattern
                            F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                            // month/day pattern
                            M: "MMMM dd",
                            // month/year pattern
                            Y: "yyyy MMMM",
                            // S is a sortable format that does not vary by culture
                            S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                            // formatting of dates in MySQL DataBases
                            ISO: "yyyy-MM-dd hh:mm:ss",
                            ISO2: "yyyy-MM-dd HH:mm:ss",
                            d1: "dd.MM.yyyy",
                            d2: "dd-MM-yyyy",
                            d3: "dd-MMMM-yyyy",
                            d4: "dd-MM-yy",
                            d5: "H:mm",
                            d6: "HH:mm",
                            d7: "HH:mm tt",
                            d8: "dd/MMMM/yyyy",
                            d9: "MMMM-dd",
                            d10: "MM-dd",
                            d11: "MM-dd-yyyy"
                        },
                        percentsymbol: "%",
                        currencysymbol: "€",
                        currencysymbolposition: "before",
                        decimalseparator: ',',
                        thousandsseparator: ',',
                        pagergotopagestring: "Vai a pagina:",
                        pagershowrowsstring: "Righe per pagina:",
                        pagerrangestring: " di ",
                        pagerpreviousbuttonstring: "indietro",
                        pagernextbuttonstring: "avanti",
                        pagerfirstbuttonstring: "primo",
                        pagerlastbuttonstring: "ultimo",
                        groupsheaderstring: "Trascina qui una colonna per effettuare un raggruppamento",
                        sortascendingstring: "Ordinamento Crescente",
                        sortdescendingstring: "Ordinamento Decrescente",
                        sortremovestring: "Rimuovi Ordinamento",
                        groupbystring: "Raggruppa per questa colonna",
                        groupremovestring: "Rimuovi dal raggruppamento",
                        filterclearstring: "Annulla",
                        filterstring: "Filtra",
                        filtershowrowstring: "Mostra se:",
                        filterorconditionstring: "O",
                        filterandconditionstring: "E",
                        filterselectallstring: "(Seleziona tutto)",
                        filterchoosestring: "",
                        filterstringcomparisonoperators: ['vuoto', 'presente', 'contiene', 'contiene (controllo maiuscole)',
                            'non contiene', 'non contiene (controllo maiuscole)', 'comincia con', 'comincia con (controllo maiuscole)',
                            'termina con', 'termina con (controllo maiuscole)', 'coincide', 'coincide (controllo maiuscole)', 'vuoto', 'presente'
                        ],
                        filternumericcomparisonoperators: ['uguale', 'diverso', 'minore di', 'minore o uguale', 'maggiore di', 'maggiore o uguale', 'vuoto', 'presente'],
                        filterdatecomparisonoperators: ['uguale', 'diverso', 'minore di', 'minore o uguale', 'maggiore di', 'maggiore o uguale', 'vuoto', 'presente'],
                        filterbooleancomparisonoperators: ['uguale', 'diverso'],
                        validationstring: "Il valore inserito non è valido",
                        emptydatastring: "Nessun dato da mostrare",
                        filterselectstring: "Scegli filtro",
                        loadtext: "Caricamento...",
                        clearstring: "Annulla",
                        todaystring: "Oggi"
                    }
                    break;
                case "en":
                default:
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 0,
                        days: {
                            // full day names
                            names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                            // abbreviated day names
                            namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                            // shortest day names
                            namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
                        },
                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""],
                            // abbreviated month names
                            namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["AM", "am", "AM"],
                        PM: ["PM", "pm", "PM"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "A.D.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            // short date pattern
                            d: "M/d/yyyy",
                            // long date pattern
                            D: "dddd, MMMM dd, yyyy",
                            // short time pattern
                            t: "h:mm tt",
                            // long time pattern
                            T: "h:mm:ss tt",
                            // long date, short time pattern
                            f: "dddd, MMMM dd, yyyy h:mm tt",
                            // long date, long time pattern
                            F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                            // month/day pattern
                            M: "MMMM dd",
                            // month/year pattern
                            Y: "yyyy MMMM",
                            // S is a sortable format that does not vary by culture
                            S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                            // formatting of dates in MySQL DataBases
                            ISO: "yyyy-MM-dd hh:mm:ss",
                            ISO2: "yyyy-MM-dd HH:mm:ss",
                            d1: "dd.MM.yyyy",
                            d2: "dd-MM-yyyy",
                            d3: "dd-MMMM-yyyy",
                            d4: "dd-MM-yy",
                            d5: "H:mm",
                            d6: "HH:mm",
                            d7: "HH:mm tt",
                            d8: "dd/MMMM/yyyy",
                            d9: "MMMM-dd",
                            d10: "MM-dd",
                            d11: "MM-dd-yyyy"
                        },
                        percentsymbol: "%",
                        currencysymbol: "$",
                        currencysymbolposition: "before",
                        decimalseparator: '.',
                        thousandsseparator: ',',
                        pagergotopagestring: "Go to page:",
                        pagershowrowsstring: "Show rows:",
                        pagerrangestring: " of ",
                        pagerpreviousbuttonstring: "previous",
                        pagernextbuttonstring: "next",
                        pagerfirstbuttonstring: "first",
                        pagerlastbuttonstring: "last",
                        groupsheaderstring: "Drag a column and drop it here to group by that column",
                        sortascendingstring: "Sort Ascending",
                        sortdescendingstring: "Sort Descending",
                        sortremovestring: "Remove Sort",
                        groupbystring: "Group By this column",
                        groupremovestring: "Remove from groups",
                        filterclearstring: "Clear",
                        filterstring: "Filter",
                        filtershowrowstring: "Show rows where:",
                        filterorconditionstring: "Or",
                        filterandconditionstring: "And",
                        filterselectallstring: "(Select All)",
                        filterchoosestring: "Please Choose:",
                        filterstringcomparisonoperators: ['empty', 'not empty', 'contains', 'contains(match case)',
                            'does not contain', 'does not contain(match case)', 'starts with', 'starts with(match case)',
                            'ends with', 'ends with(match case)', 'equal', 'equal(match case)', 'null', 'not null'
                        ],
                        filternumericcomparisonoperators: ['equal', 'not equal', 'less than', 'less than or equal', 'greater than', 'greater than or equal', 'null', 'not null'],
                        filterdatecomparisonoperators: ['equal', 'not equal', 'less than', 'less than or equal', 'greater than', 'greater than or equal', 'null', 'not null'],
                        filterbooleancomparisonoperators: ['equal', 'not equal'],
                        validationstring: "Entered value is not valid",
                        emptydatastring: "No data to display",
                        filterselectstring: "Select Filter",
                        loadtext: "Loading...",
                        clearstring: "Clear",
                        todaystring: "Today"
                    }
                    break;
                case "es":
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 1,
                        days: {
                            // full day names
                            names: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sàbado"],
                            // abbreviated day names
                            namesAbbr: ["Dom", "Lun", "Mar", "Mer", "Jue", "Vie", "Sab"],
                            // shortest day names
                            namesShort: ["Do", "Lu", "Ma", "Me", "Ju", "Vi", "Sa"]
                        },
                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre", ""],
                            // abbreviated month names
                            namesAbbr: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["AM", "am", "AM"],
                        PM: ["PM", "pm", "PM"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "A.D.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            // short date pattern
                            d: "M/d/yyyy",
                            // long date pattern
                            D: "dddd, MMMM dd, yyyy",
                            // short time pattern
                            t: "h:mm tt",
                            // long time pattern
                            T: "h:mm:ss tt",
                            // long date, short time pattern
                            f: "dddd, MMMM dd, yyyy h:mm tt",
                            // long date, long time pattern
                            F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                            // month/day pattern
                            M: "MMMM dd",
                            // month/year pattern
                            Y: "yyyy MMMM",
                            // S is a sortable format that does not vary by culture
                            S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                            // formatting of dates in MySQL DataBases
                            ISO: "yyyy-MM-dd hh:mm:ss",
                            ISO2: "yyyy-MM-dd HH:mm:ss",
                            d1: "dd.MM.yyyy",
                            d2: "dd-MM-yyyy",
                            d3: "dd-MMMM-yyyy",
                            d4: "dd-MM-yy",
                            d5: "H:mm",
                            d6: "HH:mm",
                            d7: "HH:mm tt",
                            d8: "dd/MMMM/yyyy",
                            d9: "MMMM-dd",
                            d10: "MM-dd",
                            d11: "MM-dd-yyyy"
                        },
                        percentsymbol: "%",
                        currencysymbol: "€",
                        currencysymbolposition: "before",
                        decimalseparator: '.',
                        thousandsseparator: ',',
                        pagergotopagestring: "Ir a la página:",
                        pagershowrowsstring: "Lineas por pagina:",
                        pagerrangestring: " de ",
                        pagerpreviousbuttonstring: "anterior",
                        pagernextbuttonstring: "siguiente",
                        pagerfirstbuttonstring: "primero",
                        pagerlastbuttonstring: "pasado",
                        groupsheaderstring: "Arrastre una columna aquí para agrupar",
                        sortascendingstring: "Orden ascendente",
                        sortdescendingstring: "Orden descendente",
                        sortremovestring: "Eliminar orden",
                        groupbystring: "Raggruppa per questa colonna",
                        groupremovestring: "Agrupar por esta columna",
                        filterclearstring: "cancelar",
                        filterstring: "Filtra",
                        filtershowrowstring: "Muestra si:",
                        filterorconditionstring: "O",
                        filterandconditionstring: "Y",
                        filterselectallstring: "(Seleccionar todo)",
                        filterchoosestring: "",
                        filterstringcomparisonoperators: ['vacío', 'presente', 'contiene', 'contiene (control mayúsculas)',
                            'no contiene', 'no contiene (control mayúsculas)', 'comienza con', 'comienza con (control mayúsculas)',
                            'termina con', 'termina con (control mayúsculas)', 'coincide', 'coincide (control mayúsculas)', 'vacío', 'presente'
                        ],
                        filternumericcomparisonoperators: ['igual', 'diferente', 'menor de', 'menor o igual', 'mayor de', 'mayor o igual', 'vacío', 'presente'],
                        filterdatecomparisonoperators: ['igual', 'diferente', 'menor de', 'menor o igual', 'mayor de', 'mayor o igual', 'vacío', 'presente'],
                        filterbooleancomparisonoperators: ['igual', 'diferente'],
                        validationstring: "El valor ingresado no es válido",
                        emptydatastring: "No hay datos para mostrar",
                        filterselectstring: "Elegir filtro",
                        loadtext: "Cargando...",
                        clearstring: "Cancelar",
                        todaystring: "Hoy"
                    }
                    break;
                case "fr":
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 1,
                        days: {
                            // full day names
                            names: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                            // abbreviated day names
                            namesAbbr: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                            // shortest day names
                            namesShort: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"]
                        },
                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre", ""],
                            // abbreviated month names
                            namesAbbr: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["AM", "am", "AM"],
                        PM: ["PM", "pm", "PM"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "A.D.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            // short date pattern
                            d: "M/d/yyyy",
                            // long date pattern
                            D: "dddd, MMMM dd, yyyy",
                            // short time pattern
                            t: "h:mm tt",
                            // long time pattern
                            T: "h:mm:ss tt",
                            // long date, short time pattern
                            f: "dddd, MMMM dd, yyyy h:mm tt",
                            // long date, long time pattern
                            F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                            // month/day pattern
                            M: "MMMM dd",
                            // month/year pattern
                            Y: "yyyy MMMM",
                            // S is a sortable format that does not vary by culture
                            S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                            // formatting of dates in MySQL DataBases
                            ISO: "yyyy-MM-dd hh:mm:ss",
                            ISO2: "yyyy-MM-dd HH:mm:ss",
                            d1: "dd.MM.yyyy",
                            d2: "dd-MM-yyyy",
                            d3: "dd-MMMM-yyyy",
                            d4: "dd-MM-yy",
                            d5: "H:mm",
                            d6: "HH:mm",
                            d7: "HH:mm tt",
                            d8: "dd/MMMM/yyyy",
                            d9: "MMMM-dd",
                            d10: "MM-dd",
                            d11: "MM-dd-yyyy"
                        },
                        percentsymbol: "%",
                        currencysymbol: "€",
                        currencysymbolposition: "before",
                        decimalseparator: '.',
                        thousandsseparator: ',',
                        pagergotopagestring: "Aller à la page:",
                        pagershowrowsstring: "lignes par page:",
                        pagerrangestring: " de ",
                        pagerpreviousbuttonstring: "en arrière",
                        pagernextbuttonstring: "avant",
                        pagerfirstbuttonstring: "premier",
                        pagerlastbuttonstring: "dernier",
                        groupsheaderstring: "Faites glisser une colonne ici pour regrouper",
                        sortascendingstring: "Ordre croissant",
                        sortdescendingstring: "Ordre décroissant",
                        sortremovestring: "Supprimer Ordre",
                        groupbystring: "Regrouper par cette colonne",
                        groupremovestring: "Supprimer du regroupement",
                        filterclearstring: "Annuler",
                        filterstring: "Filtrez",
                        filtershowrowstring: "Montre si:",
                        filterorconditionstring: "Ou",
                        filterandconditionstring: "Et",
                        filterselectallstring: "(Tout sélectionner)",
                        filterchoosestring: "",
                        filterstringcomparisonoperators: ['vide', 'présente', 'contient', 'contient (control majuscules)',
                            'ne contient pas', 'ne contient pas (control majuscules)', 'commence par', 'commence par (control majuscules)',
                            'se termine par', 'se termine par (control majuscules)', 'coïncide', 'coïncide (control majuscules)', 'vide', 'présente'
                        ],
                        filternumericcomparisonoperators: ['égal', 'différent', 'inférieur à', 'inférieur ou égal', 'supérieur à', 'supérieur ou égal', 'vide', 'présente'],
                        filterdatecomparisonoperators: ['égal', 'différent', 'inférieur à', 'inférieur ou égal', 'supérieur à', 'supérieur ou égal', 'vide', 'présente'],
                        filterbooleancomparisonoperators: ['égal', 'différent'],
                        validationstring: "La valeur entrée n'est pas valide",
                        emptydatastring: "Aucune donnée à afficher",
                        filterselectstring: "Choisissez le filtre",
                        loadtext: "Chargement...",
                        clearstring: "Annuler",
                        todaystring: "Aujourd'hui"
                    }
                    break;
                case "ru":
                    localization = {
                        // separator of parts of a date (e.g. '/' in 11/05/1955)
                        '/': "/",
                        // separator of parts of a time (e.g. ':' in 05:44 PM)
                        ':': ":",
                        // the first day of the week (0 = Sunday, 1 = Monday, etc)
                        firstDay: 1,
                        days: {
                            // full day names
                            names: ["воскресенье", "Понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
                            // abbreviated day names
                            namesAbbr: ["вс", "Пн", "вт", "ср", "чт", "пт", "сб"],
                            // shortest day names
                            namesShort: ["вс", "Пн", "вт", "ср", "чт", "пт", "сб"]
                        },
                        months: {
                            // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                            names: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь", ""],
                            // abbreviated month names
                            namesAbbr: ["Янв", "фев", "мар", "апр", "май", "Июнь", "Июль", "Авг", "сент", "Окт", "ноя", "дек", ""]
                        },
                        // AM and PM designators in one of these forms:
                        // The usual view, and the upper and lower case versions
                        //      [standard,lowercase,uppercase]
                        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
                        //      null
                        AM: ["утра", "утра", "утра"],
                        PM: ["вечера", "вечера", "вечера"],
                        eras: [
                            // eras in reverse chronological order.
                            // name: the name of the era in this culture (e.g. A.D., C.E.)
                            // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                            // offset: offset in years from gregorian calendar
                            {
                                "name": "н.э.",
                                "start": null,
                                "offset": 0
                            }
                        ],
                        twoDigitYearMax: 2029,
                        patterns: {
                            // short date pattern
                            d: "M/d/yyyy",
                            // long date pattern
                            D: "dddd, MMMM dd, yyyy",
                            // short time pattern
                            t: "h:mm tt",
                            // long time pattern
                            T: "h:mm:ss tt",
                            // long date, short time pattern
                            f: "dddd, MMMM dd, yyyy h:mm tt",
                            // long date, long time pattern
                            F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                            // month/day pattern
                            M: "MMMM dd",
                            // month/year pattern
                            Y: "yyyy MMMM",
                            // S is a sortable format that does not vary by culture
                            S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                            // formatting of dates in MySQL DataBases
                            ISO: "yyyy-MM-dd hh:mm:ss",
                            ISO2: "yyyy-MM-dd HH:mm:ss",
                            d1: "dd.MM.yyyy",
                            d2: "dd-MM-yyyy",
                            d3: "dd-MMMM-yyyy",
                            d4: "dd-MM-yy",
                            d5: "H:mm",
                            d6: "HH:mm",
                            d7: "HH:mm tt",
                            d8: "dd/MMMM/yyyy",
                            d9: "MMMM-dd",
                            d10: "MM-dd",
                            d11: "MM-dd-yyyy"
                        },
                        percentsymbol: "%",
                        currencysymbol: "€",
                        currencysymbolposition: "before",
                        decimalseparator: '.',
                        thousandsseparator: ',',
                        pagergotopagestring: "Перейти на страницу:",
                        pagershowrowsstring: "Ряды на страницу:",
                        pagerrangestring: " с ",
                        pagerpreviousbuttonstring: "обратно",
                        pagernextbuttonstring: "вперед",
                        pagerfirstbuttonstring: "первый",
                        pagerlastbuttonstring: "последний",
                        groupsheaderstring: "Перетащите колонку сюда, чтобы сделать группировку",
                        sortascendingstring: "Сортировка восхода",
                        sortdescendingstring: "Сортировка по убыванию",
                        sortremovestring: "Удалить Сортировать",
                        groupbystring: "Группа для этой колонки",
                        groupremovestring: "Удалить из группировки",
                        filterclearstring: "отменить",
                        filterstring: "фильтровать",
                        filtershowrowstring: "показать ли:",
                        filterorconditionstring: "или",
                        filterandconditionstring: "и",
                        filterselectallstring: "(Выберите все)",
                        filterchoosestring: "",
                        filterstringcomparisonoperators: ['пустой', 'присутствует', 'содержит', 'содержит (прописной контроль)',
                            'не содержит', 'не содержит (прописной контроль)', 'начинаться с', 'начинаться с (прописной контроль)',
                            'заканчивается', 'заканчивается (прописной контроль)', 'совпадает с', 'совпадает с (прописной контроль)', 'пустой', 'присутствует'
                        ],
                        filternumericcomparisonoperators: ['равный', 'другой', 'меньше, чем', 'меньше или равно', 'нечто большее, чем', 'больше или равно', 'пустой', 'присутствует'],
                        filterdatecomparisonoperators: ['равный', 'другой', 'меньше, чем', 'меньше или равно', 'нечто большее, чем', 'больше или равно', 'пустой', 'присутствует'],
                        filterbooleancomparisonoperators: ['равный', 'другой'],
                        validationstring: "Введенное значение недействительно",
                        emptydatastring: "Нет данных, чтобы показать",
                        filterselectstring: "Выберите фильтр",
                        loadtext: "Загрузка...",
                        clearstring: "отменить",
                        todaystring: "сегодня"
                    }
                    break;
            }
            return localization;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/dynamic/jqwGridWrapper/localization.js